import TwillioVideoComponent from "./TwillioVideoComponent";

const PublicVideoCall = () => {
  return (
    <div className="flex h-screen flex-col bg-gray-900 overflow-hidden">
      <div className="bg-gray-800 p-4 text-white">
        <div className="flex justify-between items-center">
          <div>
            <div className="text-lg font-medium">
              Patient Name: Sarah Johnson
            </div>
            <div className="flex items-center mt-1">
              <div className="w-3 h-3 rounded-sm mr-2 bg-blue-500"></div>
              <span className="text-sm">Video Call</span>
            </div>
          </div>
          <div className="text-sm text-right">
            <div>Monday July 22, 2024</div>
            <div className="mt-1">10:00 AM – 10:15 AM (15 minutes)</div>
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-row gap-4  p-4 min-h-0 h-full">
        <TwillioVideoComponent />
      </div>
    </div>
  );
};

export default PublicVideoCall;
